// extracted by mini-css-extract-plugin
module.exports = {"reviews-component":"Reviews_reviews-component__npiq1","reviews-item":"Reviews_reviews-item__fQp81","reviews-more":"Reviews_reviews-more__7yCWG","icon":"Reviews_icon__xAH5M"};